'use strict';

import 'angular';

import codeController from './controller';

const MODULE_NAME = 'daupler.users.code';

var app = angular.module(MODULE_NAME, [
]);
app.controller('CodeController', codeController);

export default MODULE_NAME;
